import PropTypes from "prop-types"
import Loading from "components/material/loading"
import { ERROR, LOADING, OK } from "helpers/data-statuses"

export default function CompareGraphStatus({ status }) {
  if (status === OK) {
    return null
  }

  return <div className="renderers_compare-graph-loading">
    {status === LOADING && <Loading />}
    {status === ERROR && <div>An error occurred</div>}
  </div>
}

CompareGraphStatus.propTypes = {
  status: PropTypes.string.isRequired,
}
